module.exports = __webpack_public_path__ + "static/img/hqicon.ccc48e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/hqicon.png
// module id = 4rR8
// module chunks = 7